const ModalFooterTheme = {
  wrapper:
    "flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50",
};

export default ModalFooterTheme;
